export default __webpack_public_path__ + "b94ea171e94714c614bd093f34b30193.svg";